<template>
  <div
    class="data-card-panel"
    :style="{ background: (list[0] && list[0].gradient) || 'none' }"
  >
    <div v-for="(item, index) in list" :key="index" class="data-item">
      <!-- 左上角标题标签 -->
      <div
        class="title-tag"
        :style="{ background: item.tagColor || '#4F6BFF' }"
      >
        {{ item.title }}
        <span class="sub-title" v-if="item.subTitle">{{ item.subTitle }}</span>
      </div>
      <!-- 数值区域 -->
      <div class="top">
        <div class="card-content">
          <div class="value-area">
            <span
              class="value"
              :style="{
                fontSize: formatNumber(item.value).length > 9 ? '22px' : '28px',
              }"
              >{{ formatNumber(item.value) }}</span
            >
            <span
              class="unit"
              :style="{
                fontSize: formatNumber(item.value).length > 9 ? '18px' : '28px',
              }"
              >{{ item.unit }}
            </span>
            <!-- v-if="item.unit">{{ item.unit }}</span> -->
          </div>
        </div>
      </div>

      <!-- 对比区域 -->
      <div class="bottom">
        <div
          class="card-footer"
          :style="{
            filter: name != '较上段' ? 'grayscale(0)' : 'grayscale(100%)',
          }"
        >
          <span class="compare-label">{{ name }}：</span>
          <div class="trend-badge" :class="item.isUp ? 'up' : 'down'">
            <span class="trend-value">
              {{ name != "较上段" ? item.compareValue : "--" }}</span
            >
            <i
              v-show="name != '较上段'"
              :class="item.isUp ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"
            ></i>
          </div>
        </div>
      </div>
      <!-- 垂直分割线（最后一个不显示） -->
      <div class="divider" v-if="index < list.length - 1"></div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DataCard",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: "较上月",
    },
  },
  methods: {
    formatNumber(val) {
      if (val === undefined || val === null) return "0";
      let str = val.toString();
      let parts = str.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
  },
};
</script>

<style scoped lang="scss">
.data-card-panel {
  display: flex;
  width: fit-content;
  align-items: center;
  // background: linear-gradient(180deg, #DCDFFF 0%, #FFFFFF 100%);
  border-radius: 16px 0px 0px 0px;

  .data-item {
    width: 215px;
    height: 149px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    // 标题标签样式
    .title-tag {
      width: fit-content;
      padding: 7px;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      text-align: left;
      border-radius: 12px 0px 24px 0px; // 符合图一的圆角风格
      white-space: nowrap;
      .sub-title {
        margin-top: 4px;
        font-weight: 400;
        font-size: 11px;
        line-height: 16px;
      }
    }

    .top {
      padding-left: 20px;

      // 数值内容
      .card-content {
        margin-top: 14px;

        .value-area {
          display: flex;
          align-items: baseline;
          color: #000000;
          font-family: "AlibabaPuHuiTi_2_55_Regular", sans-serif;

          .value {
            font-weight: bold;
            // font-size: 24px;
            color: #000000;
            line-height: 28px;
          }

          .unit {
            // font-size: 18px;
            font-weight: bold;
            margin-left: 2px;
          }
        }
      }
    }

    .bottom {
      padding-left: 20px;
      padding-bottom: 16px;
    }

    // 对比趋势
    .card-footer {
      display: flex;
      align-items: center;
      margin-top: 16px;
      font-size: 14px;
      font-family: "AlibabaPuHuiTi_2_55_Regular", sans-serif;

      .compare-label {
        color: #666666;
      }

      .trend-badge {
        display: flex;
        align-items: center;
        padding: 1px 8px;
        border-radius: 4px;
        gap: 2px;
        font-weight: 500;

        &.up {
          background: #e6f7ed;
          color: #16c064;
        }

        &.down {
          background: #fff1f0;
          color: #f5222d;
        }
      }
    }

    // 垂直分割线样式
    .divider {
      position: absolute;
      right: 0;
      top: 16%;
      bottom: 20%;
      width: 1px;
      height: 100px;
      background: linear-gradient(to bottom, transparent, #eeeeee, transparent);
    }
  }
}
</style>
